import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";

@Injectable({
	providedIn: "root"
})
export class StakingResolver {
	constructor(private router: Router) {}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
		const navigationStakeableId = this.router.currentNavigation()?.extras?.state?.stakeableId;
		if (navigationStakeableId) {
			return navigationStakeableId;
		}

		const assetIdFromQuery = route.queryParamMap.get("assetId") ?? route.queryParamMap.get("stakeableId");
		if (assetIdFromQuery) {
			return assetIdFromQuery;
		}

		const assetIdFromParams = route.paramMap.get("assetId") ?? route.parent?.paramMap?.get("assetId");
		return assetIdFromParams ?? "";
	}
}
